import { render, staticRenderFns } from "./VideoViewer.vue?vue&type=template&id=0f732561&scoped=true"
import script from "./VideoViewer.vue?vue&type=script&lang=js"
export * from "./VideoViewer.vue?vue&type=script&lang=js"
import style0 from "./VideoViewer.vue?vue&type=style&index=0&id=0f732561&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f732561",
  null
  
)

export default component.exports